import { i18nMark } from 'lingui-react';

const formattedMessages = {
  engine: i18nMark('Engine'),
  make: i18nMark('Make'),
  model: i18nMark('Model'),
  odometer: i18nMark('Odometer'),
  other: i18nMark('Other'),
  pmStatus: i18nMark('Maintenance'),
  serial: i18nMark('Serial No.'),
  unitNumber: i18nMark('Unit'),
  vin: i18nMark('VIN'),
  year: i18nMark('Year'),
};

export default formattedMessages;



// WEBPACK FOOTER //
// ./components/AssetsPanel/messages.js